import SearchEngineAdapter from 'Services/Adapters/SearchEngine/SearchEngineAdapter';
import SalesDocumentsStatus from 'Config/authenticated/SalesDocumentsStatus';

export default class RedactorAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'redactor';
    }

    constructor(data = []) {
        super(data);
        this.key = RedactorAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Redactor'),
            icon: 'icon-document',
            count: 0,
            items: [],
        };
    }

    formatItem(item) {
        let status;
        let number;
        switch (item.object.sub_type) {
            case 'document':
                number = item.ident;
                status = {
                    color: SalesDocumentsStatus[item.object.sub_type][item.step].chipColor,
                    label: SalesDocumentsStatus[item.object.sub_type][item.step].label,
                };
                break;
            default:
                number = item.name;
                break;
        }

        return {
            id: item.object.id,
            number,
            object: item.object,
            type: item.object.type,
            sub_type: item.object.sub_type,
            related: {
                name: item.related?.name,
            },
            amount: window.sellsyapp.$filters.numberFormatCurrencyCustomNumberFormat(item.amount, {
                currency: item.currency,
                currencysymbol: item.currency,
            }),
            status,
            link: `/?_f=proposal_proposal&type=prop${item.object.sub_type}&id=${item.object.id}`,
            component: 'search-result-sales-document',
        };
    }
}
